<template>
  <v-app>
    <cv-header></cv-header>
    <v-main>
      <router-view> </router-view>
    </v-main>
    <v-dialog
      v-model="noticeDialog"
      max-width="820"
      content-class="notice-dialog"
    >
      <div class="notice-card">
        <div class="notice-icon">
          <v-icon color="#2f5bea" size="28">mdi-shield-check-outline</v-icon>
        </div>
        <h2 class="notice-title">
          <span class="notice-title-accent">[공지]</span>
          채용홈페이지 접속 화면 임시 변경 안내
        </h2>
        <hr class="notice-divider" />
        <div class="notice-body">
          <p>
            최근 보도된 웹 보안 취약점 이슈에 선제적으로 대응하기 위해,<br />
            보안 점검 기간 동안 채용홈페이지 메인 화면을 임시로
            <strong> '채용공고 목록'</strong> 화면으로 연결하고 있습니다.
          </p>
          <p>
            <strong
              >공고 확인, 지원서 작성 및 제출 등 채용 관련 서비스는 기존과 같이
              이용하실 수 있으며,</strong
            ><br />
            <strong
              >작성 중이거나 제출하신 지원서 내용도 문제없이 유지되고
              있습니다.</strong
            ><br />
            이번 조치는 사전 예방 차원에서 진행하는 것으로, 지원자분들의
            개인정보는 안전하게 보호되고 있습니다.
          </p>
          <div class="notice-tip">
            ※ <strong>'지원하기'</strong>가 정상적으로 동작하지 않는 경우,
            브라우저에 저장된 이전 화면(캐시)이 남아 있을 수 있습니다.<br />
            키보드의 <strong>Ctrl + Shift + R</strong> (Mac:
            <strong>Cmd + Shift + R</strong>)을 눌러 새로고침하시거나,
            <strong>시크릿창</strong>에서 다시 시도해 주시기 바랍니다.
          </div>
          <p>이용에 불편을 드려 죄송합니다.</p>
        </div>
        <div class="notice-actions">
          <v-btn color="#2f5bea" dark depressed @click="noticeDialog = false">
            확인
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </v-app>
</template>

<script>
import CvHeader from '@/components/common/CvHeader';

const NOTICE_TENANTS = ['infac', 'mecaro', 'yonsung', 'nhcapital', 'isugroup'];

//import LoginForm from '@/components/LoginForm.vue';
export default {
  components: {
    //LoginForm,
    CvHeader,
  },
  data() {
    return {
      noticeDialog: false,
    };
  },
  mounted: function() {
    console.log(this.$route.params);
    this.$store.commit('setTenant', this.$route.params.tenantKey);
    this.noticeDialog = NOTICE_TENANTS.includes(this.$route.params.tenantKey);
  },
};
</script>

<style scoped>
.notice-card {
  position: relative;
  background: #fff;
  border-radius: 28px;
  border-top: 6px solid #3b63e8;
  padding: 40px 48px 32px;
  overflow: hidden;
}
.notice-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #eef2fd;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notice-title {
  margin: 28px 0 0;
  font-size: 26px;
  font-weight: 800;
  color: #111827;
}
.notice-title-accent {
  color: #2f5bea;
}
.notice-divider {
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin: 24px 0;
}
.notice-body p {
  margin: 0 0 24px;
  font-size: 16px;
  line-height: 2;
  color: #4b5563;
}
.notice-tip {
  margin: 0 0 24px;
  padding: 16px 20px;
  border-radius: 12px;
  background: #eef2fd;
  font-size: 14px;
  line-height: 1.8;
  color: #4b5563;
}
.notice-body strong {
  color: #111827;
}
.notice-actions {
  text-align: right;
}
</style>
